import { useContext, useEffect, useRef } from "react";
import { ElementRect, useElementRect } from "../../../hooks/useElementRect";
import { useComponentLoadUnload } from "../../../services/helpers";
import { Box, SxProps } from "@mui/material";
import React from "react";
import { RectUpdateContext } from "./FlexContainer";

const useRectUpdate = () => useContext(RectUpdateContext);

interface FlexChild {
    children: React.ReactNode;
    onReport?: (rect: ElementRect) => void;
    order?: number;
    flex?: string;
    alignSelf?: 'auto' | 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch';
    fillRemainingHeight?:boolean;
    containerHeight?:number
    sx?: SxProps;
  }
  
const FlexChild: React.FC<FlexChild> = ({
    children,
    onReport,
    order,
    flex="0 1 auto",
    alignSelf,
    fillRemainingHeight,
    sx,
    ...rest // Capture the rest of the props
  }) => {
    // useComponentLoadUnload(
    //     'FlexChild',
    //     () => {    },
    //     () => {    }
    // );  
    // const [modeRef, modeRect] = useElementRect();
    const [modeRef, modeRect, updateRect] = useElementRect();
    const { registerUpdate, forceUpdate, containerRect } = useRectUpdate();

    useEffect(() => {
    //   console.log(order,modeRect)
    //   const updateRect = () => {

    //   };
  
      // Generate a unique ID for each ReportableBox instance
      const id = `reportable-box-${Math.random().toString(36).slice(2, 9)}`;

      // Register this box's updateRect function
      registerUpdate(id, updateRect);
  
      // Optionally, call updateRect on mount to immediately report dimensions
      updateRect();
  
      // Cleanup: Unregister the update function when the component unmounts
    //   return () => registerUpdate(id, null); // Assuming your registerUpdate can handle unregistration
    }, []);
    const lastReportedRectRef = useRef({ top: 0, left: 0, bottom: 0, right: 0 });

    useEffect(() => {
        if (!modeRect) return
        // Destructure the necessary properties from modeRect
        const { top, left, bottom, right } = modeRect || {};
        // Destructure the last reported values for comparison
        const lastRect = lastReportedRectRef.current;
      
        // Check if any of the properties have changed
        if (top !== lastRect.top || left !== lastRect.left || bottom !== lastRect.bottom || right !== lastRect.right) {
          // console.log(modeRect)
          // Only call onReport if one of the values has changed
          onReport?.(modeRect);
      
          // Update the ref with the new values
          lastReportedRectRef.current = { top, left, bottom, right };
        }
      }, [modeRect]);
      
    
    const lastAdjustedHeightRef = useRef<number | null>(null); // Initialize with null to indicate no previous value

    useEffect(() => {
      if (fillRemainingHeight && modeRect && containerRect.height && modeRef.current && modeRect.top) {
        // console.log(`Parent height: ${containerRect.height}, Top of green: ${modeRect.top - containerRect.top}`)
        const adjustedHeight = containerRect.height - (modeRect.top - containerRect.top);
        
        // Check if adjustedHeight has changed since the last render
        if (lastAdjustedHeightRef.current !== adjustedHeight) {
            // console.log(containerRect.height, modeRect.top, containerRect.top, adjustedHeight);
            modeRef.current.style.height = `${adjustedHeight}px`;
            // Update lastAdjustedHeightRef with the new adjustedHeight
            lastAdjustedHeightRef.current = adjustedHeight;
    
          // Optionally, report back the new dimensions
          // Ensure this does not trigger the effect in an infinite loop
        //   if (onReport) {
        //     onReport({ ...modeRect, height: adjustedHeight }); // You may need to adjust this object structure based on your needs
        //   }
        }
      }
    }, [modeRect, containerRect, onReport, fillRemainingHeight]);
    
    
    return (
      <Box
        ref={modeRef}
        sx={{
          order,
          flex,
          alignSelf,
          ...sx, 
          ...rest 
        }}
      >
        {children}
      </Box>
    );
};

export default FlexChild